// The lexicon NSID for the quiz record written into each user's own repo.
// NSIDs are reverse-domain: change this to a domain you control (e.g. "com.yourname.skymate.quiz").
export const COLLECTION = 'app.skymate.quiz';
export const RKEY = 'self';

// OAuth scope: base atproto + create/update on our one record type. Nothing else.
export const OAUTH_SCOPE = `atproto repo:${COLLECTION}?action=create&action=update`;

// Minimum questions two people must both have answered before we'll show a score.
export const MIN_COMMON = 8;
